// 德语
export const GUIDES = [
  { name: 'guide-overview', title: 'Überblick über die Funktionen', groupIndex: 0 },
  { name: 'guide-account', title: 'Über das Konto', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'Über das Fahrzeug', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Einrichten des Armaturenbretts', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Wie man das Fahrzeug einrichtet', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Navigieren, um das Fahrzeug zu finden', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Wie man die Navigation benutzt', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Über die Fahrtenhistorie', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Wie man eine Selbstinspektion des Fahrzeugs durchführt', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'So nehmen Sie allgemeine APP-Einstellungen vor', groupIndex: 3 },
  { name: 'guide-notice', title: 'So zeigen Sie Nachrichtenbenachrichtigungen an und stellen sie ein', groupIndex: 3 },
  { name: 'guide-about', title: 'Über APP', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'Ausstehend',
  1: 'Keine Antwort',
  2: 'Antwort',
  3: 'in Kommunikation',
  4: 'Gegenmaßnahmen',
  5: 'gelöst',
};

export const FEEDBACK_TYPES = {
  1: 'Rückmeldung',
  2: 'Antwort',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
